import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Datastore, DatastoreDocument } from '@freelancer/datastore';
import { NextPreviousUsersCollection } from '@freelancer/datastore/collections';
import { LinkColor } from '@freelancer/ui/link';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-user-profile-next-previous-users',
  template: `
    <ng-container
      *ngIf="
        nextPreviousUsersDocument.valueChanges() | flAsync as nextPreviousUsers
      "
    >
      <fl-bit class="UsersNavigationContainer">
        <fl-link
          [color]="LinkColor.DARK"
          [link]="'/u/' + nextPreviousUsers.previousUsername"
          i18n="Previous user link label"
          flTrackingLabel="PreviousUserButton"
        >
          <fl-icon [name]="'ui-arrow-left'"></fl-icon>
          Previous User
        </fl-link>

        <fl-link
          [color]="LinkColor.DARK"
          [link]="'/u/' + nextPreviousUsers.nextUsername"
          i18n="Next user link label"
          flTrackingLabel="NextUserButton"
        >
          Next User
          <fl-icon [name]="'ui-arrow-right'"></fl-icon>
        </fl-link>
      </fl-bit>
    </ng-container>
  `,
  styleUrls: ['./user-profile-next-previous-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileNextPreviousUsersComponent implements OnInit {
  LinkColor = LinkColor;

  @Input() profileUserId$: Rx.Observable<number>;

  nextPreviousUsersDocument: DatastoreDocument<NextPreviousUsersCollection>;

  constructor(private datastore: Datastore) {}

  ngOnInit() {
    this.nextPreviousUsersDocument = this.datastore.document<NextPreviousUsersCollection>(
      'nextPreviousUsers',
      this.profileUserId$,
    );
  }
}
